// extracted by mini-css-extract-plugin
module.exports =  {"content":"_35875ce240--content--oTCcM","footer-buttons":"_35875ce240--footer-buttons--wKynG"};